import React, { useEffect } from "react";
import MenuPdf from "../../components/MenuPdf/MenuPdf";
import BackButton from "../../components/BackButton/BackButton";
import "../IndexPage/IndexPage.css";

function WhiskyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <BackButton />
      <div className="whisky-background"></div>
      <div className="card-container">
        <MenuPdf slug="whisky" className="pdf-sake" alt="Whisky japonés" />
      </div>
    </div>
  );
}

export default WhiskyPage;
